import React from 'react'
import Link from 'gatsby-link'

import Fill from '../../images/Fill.svg'

const WebsolutionsSidebar = () => (
  <section>
    <article>
      <div style={{display:'block'}}>
        <h1 className='smallerHone'>Web Solutions</h1>
        <img src={Fill} alt="Nisadhya - Divider" style={{margin:'0.75rem 0'}}/><br/>
        <Link to="/services/web-solutions/website-design/" className='slide'>Website Design</Link><br/>
        <Link to="/services/web-solutions/website-development/" className='slide'>Website Development</Link><br/>
        <Link to="/services/web-solutions/web-hosting/" className='slide'>Web Hosting</Link><br/>
        <Link to="/services/web-solutions/domain-registration/" className='slide'>Domain Registration</Link><br/>
      </div>
    </article>
  </section>
)

export default WebsolutionsSidebar



// WEBPACK FOOTER //
// ./src/components/WebsolutionsSidebar/index.js